module.exports = __webpack_public_path__ + "6ed76ac6751a7ca37c8d9880d96b88cd.pdf";